import { useMutation } from 'react-query';

import { roleDelete as mutationFn } from 'api/endPoints/roleDelete';

export const useMutationDeleteRole = () => {
    return useMutation<any, QueryError, string>((params) => mutationFn(params));
};
